export default __webpack_public_path__ + "static/media/spinner.99e8d1f7.svg";